import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/sino-lotQuoted/lotQuoted/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const priceList = (current, size, params) => {
  return request({
    url: '/api/sino-lotQuoted/lotQuoted/priceList',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/sino-lotQuoted/lotQuoted/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/sino-lotQuoted/lotQuoted/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/sino-lotQuoted/lotQuoted/submit',
    method: 'post',
    data: row
  })
}

export const cmsQuoted = (row) => {
  return request({
    url: '/api/sino-lotQuoted/lotQuoted/cmsQuoted',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/sino-lotQuoted/lotQuoted/submit',
    method: 'post',
    data: row
  })
}

